import { useContext } from 'react';
import VideosContext from './VideosContext';

const useVideos = () => {
  return useContext(VideosContext);
};

export default useVideos;
